/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const orgOrganizationStaffCloseShiftCreatePathOrganizationIdSchema = z.uuid();

export const orgOrganizationStaffCloseShiftCreatePathStaffIdSchema = z.uuid();

export const orgOrganizationStaffCloseShiftCreateStatus200Schema = z.any();

export const orgOrganizationStaffCloseShiftCreateResponseSchema = orgOrganizationStaffCloseShiftCreateStatus200Schema;
